import { apiRequest } from "@services/apiClient";
import cmsUsersEndpoints from "@services/cmsUsers/cmsUsersEndpoints";

const emptyPagination = {
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 1,
};

function normalizePagination(pagination) {
  return {
    page: Number(pagination?.page || emptyPagination.page),
    limit: Number(pagination?.limit || emptyPagination.limit),
    total: Number(pagination?.total || emptyPagination.total),
    totalPages: Math.max(1, Number(pagination?.totalPages || emptyPagination.totalPages)),
  };
}

function normalizeUsersBody(body) {
  return {
    users: Array.isArray(body?.users) ? body.users : [],
    pagination: normalizePagination(body?.pagination),
  };
}

function normalizeUserDetailBody(body) {
  return body?.user && typeof body.user === "object" ? body.user : null;
}

function normalizeAdminsBody(body) {
  return {
    admins: Array.isArray(body?.admins) ? body.admins : [],
    pagination: normalizePagination(body?.pagination),
  };
}

export async function listCmsUsersRequest(params) {
  const response = await apiRequest(cmsUsersEndpoints.list(params));
  return {
    ...response,
    body: normalizeUsersBody(response?.body),
  };
}

export async function getCmsUserDetailRequest(id) {
  const response = await apiRequest(cmsUsersEndpoints.byId(id));
  return {
    ...response,
    body: normalizeUserDetailBody(response?.body),
  };
}

export function exportCmsUserRequest(id, format = "csv") {
  return apiRequest(cmsUsersEndpoints.export(id, format), {
    responseType: "blob",
  });
}

export function exportAllCmsUsersRequest(format = "csv") {
  return apiRequest(cmsUsersEndpoints.exportAll(format), {
    responseType: "blob",
  });
}

export async function assignCmsUserAdminRoleRequest(id) {
  const response = await apiRequest(cmsUsersEndpoints.adminRole(id), {
    method: "POST",
  });
  return {
    ...response,
    body: normalizeUserDetailBody(response?.body),
  };
}

export async function removeCmsUserAdminRoleRequest(id) {
  const response = await apiRequest(cmsUsersEndpoints.adminRole(id), {
    method: "DELETE",
  });
  return {
    ...response,
    body: normalizeUserDetailBody(response?.body),
  };
}

export async function listCmsAdminsRequest(params) {
  const response = await apiRequest(cmsUsersEndpoints.admins(params));
  return {
    ...response,
    body: normalizeAdminsBody(response?.body),
  };
}

export async function assignCmsAdminTourRequest(id, tourId) {
  const response = await apiRequest(cmsUsersEndpoints.adminTour(id), {
    method: "PUT",
    body: {
      tourId: String(tourId || ""),
    },
  });
  return {
    ...response,
    body: normalizeUserDetailBody(response?.body),
  };
}

export async function removeCmsAdminTourRequest(id, tourId) {
  const response = await apiRequest(cmsUsersEndpoints.adminTour(id), {
    method: "DELETE",
    body: {
      tourId: String(tourId || ""),
    },
  });
  return {
    ...response,
    body: normalizeUserDetailBody(response?.body),
  };
}
